import { DialogContent, Modal } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import Text from '../Text';
import { fontSizes } from '../../constants/constants';
import { setToastData } from '../../store/slices/commonSlice';
import { getContentKeyAccToLang } from '../../utils/utils';
import dynamicfunction from '../../utils/dynamicfunction';

const ErrorModal = () => {
  const dispatch = useDispatch();
  const { isArabic } = dynamicfunction();

  const { show_toast_modal, toast_description, is_error } = useSelector((state) => state.common);
  const dashboardContent = useSelector((state) => state.content?.dashboardContent);

  const handleClose = () => {
    dispatch(
      setToastData({
        show_toast_modal: false,
        toast_description: '',
      })
    );
  };

  const getContentKey = (key) => {
    return getContentKeyAccToLang(dashboardContent, key, isArabic);
  };

  return (
    <Modal open={show_toast_modal}>
      <DialogContent className='p-0 sm:min-w-96 flex h-full items-center justify-center'>
        <div className='flex flex-col items-center justify-center bg-white rounded-md pt-3 w-full max-w-96'>
          <ReactSVG src={icons.modalCross} className='self-end cursor-pointer mr-3' onClick={handleClose} />
          <ReactSVG src={is_error ? icons.error_icon : icons.success_icon} className='mx-auto mb-4' />

          <div className='px-4'>
            <Text text={toast_description ?? ''} className={'whitespace-pre-line'} size={fontSizes.h14} isTruncate={false} isCenter />
          </div>

          <div className='border-t border-t-grey p-3 mt-3 w-full cursor-pointer' onClick={handleClose}>
            <Text text={getContentKey('dismiss')} isCenter />
          </div>
        </div>
      </DialogContent>
    </Modal>
  );
};

export default ErrorModal;
